/* eslint-disable */

export default {
    name: 'VisitorNav',
    props: {
        navs: { type: Array },
    },
};